<template>
    <div class="index">
        <!-- 顶部主要内容区域 -->
        <div id="index-top-info" class="w df">
            <!-- 左侧轮播区域 -->
            <div class="left pr oh df-shrink">
                <div class="carousel-wrapper">
                    <el-carousel trigger="click" height="340px">
                        <el-carousel-item @click.native="linkTo(item)" v-for="item in banners" :key="item.id">
                            <img :src="item.imgUrl">
                            <p>{{ item.title }}</p>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>

            <!-- 右侧新闻标签区域 -->
            <div class="index-info-box df-flex-auto oh">
                <div class="tab-box w df align-center df-between">
                    <div class="tab w fz">
                        <a href="javascript:;" :class="{on: activeTab === 'dynamic'}" @click="switchTab('dynamic')">协会动态</a>
                        <a href="javascript:;" :class="{on: activeTab === 'news'}" @click="switchTab('news')">行业资讯</a>
                        <a href="javascript:;" :class="{on: activeTab === 'notice'}" @click="switchTab('notice')">协会公告</a>
                    </div>
                    <a class="more df-shrink" href="javascript:;" @click="goToMore()">更多</a>
                </div>

                <div class="info-list w">
                    <!-- 协会动态内容 -->
                    <ul class="w" :class="{on: activeTab === 'dynamic'}">
                        <li v-for="(item, index) in dataDynamic.slice(0, 6)" :key="item.id">
                            <a class="df align-center oh" @click="onClickDataFocus(item)" href="javascript:;">
                                <span class="title df-flex-auto th">{{ item.title }}</span>
                                <em class="time df-shrink">{{ item.createTime }}</em>
                            </a>
                        </li>
                    </ul>

                    <!-- 行业资讯内容 -->
                    <ul class="w" :class="{on: activeTab === 'news'}">
                        <li v-for="(item, index) in dataIndustryNews.slice(0, 6)" :key="item.id">
                            <a class="df align-center oh" @click="onClickData(item)" href="javascript:;">
                                <span class="title df-flex-auto th">{{ item.title }}</span>
                                <em class="time df-shrink">{{ item.createTime }}</em>
                            </a>
                        </li>
                    </ul>

                    <!-- 协会公告内容 -->
                    <ul class="w" :class="{on: activeTab === 'notice'}">
                        <li v-for="(item, index) in dataNotice.slice(0, 6)" :key="item.id">
                            <a class="df align-center oh" @click="dataNoticeClick(item)" href="javascript:;">
                                <span class="title df-flex-auto th">{{ item.title }}</span>
                                <em class="time df-shrink">{{ item.createTime }}</em>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 登录按钮区域 -->
        <div id="index-type" class="w df df-between">
            <a class="df align-center df-justify-center df-shrink" @click="jump" href="javascript:;">
                <img :src="imgM" alt="会员登录">
                <em>会员登录</em>
            </a>
            <a class="df align-center df-justify-center df-shrink" @click="jump" href="javascript:;">
                <img :src="imgE" alt="专家登录">
                <em>专家登录</em>
            </a>
            <a class="df align-center df-justify-center df-shrink" @click="jump" href="javascript:;">
                <img :src="imgP" alt="其他用户">
                <em>其他用户</em>
            </a>
            <a class="df align-center df-justify-center df-shrink" @click="jump(1)" href="javascript:;">
                <img :src="imgZ" alt="用户注册">
                <em>用户注册</em>
            </a>
        </div>

        <!-- 主要内容区域 -->
        <div id="index-center-info" class="w df df-between oh">
            <!-- 消毒知识和技能培训 -->
            <div class="left">
                <div class="index-info-box oh">
                    <div class="tab-box w df align-center df-between">
                        <div class="tab w fz">
                            <a class="on" href="javascript:;">消毒知识和技能培训</a>
                        </div>
                        <a class="more df-shrink" href="javascript:;" @click="$router.push('/training')">更多</a>
                    </div>
                    <div class="info-list w">
                        <ul class="w on">
                            <li v-for="(item, index) in dataTraining.slice(0, 5)" :key="item.id">
                                <a class="df align-center oh" @click="dataTrainingClick(item)" href="javascript:;">
                                    <span class="title df-flex-auto th">{{ item.title }}</span>

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 备案管理 -->
            <div class="right">
                <div class="index-info-box oh">
                    <div class="tab-box w df align-center df-between">
                        <div class="tab w fz">
                            <a class="on" href="javascript:;">备案管理</a>
                        </div>
                        <a class="more df-shrink" href="javascript:;" @click="$router.push('/record')">更多</a>
                    </div>
                    <div class="info-list w">
                        <ul class="w on">
                            <li v-for="(item, index) in listData" :key="item.id">
                                <a class="df align-center oh" @click="recordClick(item)" href="javascript:;">
                                    <span class="title df-flex-auto th">{{ item.name }}</span>
                                    <em class="time df-shrink">备案信息</em>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 会员资讯 -->
            <div class="video-box index-info-box">
                <div class="tab-box w df align-center df-between">
                    <div class="tab w fz">
                        <a class="on">会员资讯</a>
                    </div>
                    <a class="more df-shrink" href="javascript:;" @click="$router.push('/member-news')">更多</a>
                </div>
                <div class="info-list w">
                    <ul class="w on">
                        <li v-for="(item, index) in noticeData.slice(0, 5)" :key="item.id">
                            <a class="df align-center oh" @click="noticeClick(item)" href="javascript:;">
                                <span class="title df-flex-auto th">{{ item.title }}</span>
                                <em class="time df-shrink">{{ item.createTime }}</em>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 会员展示区域 -->
        <div class="member-showcase-section">
            <div class="container">
                <div class="showcase-header" style="height: 30px;margin-bottom: 40px;">
                    <h2><i class="el-icon-user-solid"></i>会员展示</h2>
                    <p>优秀会员单位风采展示</p>
                </div>
                <div class="member-scroll">
                    <vue-seamless-scroll :data="logoData" :class-option="classOption" class="scroll-wrapper">
                        <ul class="member-logos">
                            <li v-for="(item, index) in logoData" :key="index" @click="imgClick(item)" class="logo-item">
                                <img :src="item.logo" alt="">
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>

        <!-- 友情链接 -->
        <div class="links-section">
            <div class="container">
                <div class="links-header">
                    <img src="../../assets/image/nimg.png" alt="">
                    <h2>友情链接</h2>
                </div>
                <div class="links-grid">
                    <div class="link-group">
                        <label>会员单位</label>
                        <el-select v-model="CompanyValue" placeholder="请选择会员单位" @change="comChange(CompanyValue)">
                            <el-option v-for="item in CompanyLink" :key="item.name" :label="item.name" :value="item.url">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="link-group">
                        <label>政府部门</label>
                        <el-select v-model="departmentValue" placeholder="请选择政府部门" @change="depChange(departmentValue)">
                            <el-option v-for="item in departmentLink" :key="item.name" :label="item.name" :value="item.url">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="link-group">
                        <label>协会组织</label>
                        <el-select v-model="organizationValue" placeholder="请选择协会组织" @change="orgChange(organizationValue)">
                            <el-option v-for="item in organizationLink" :key="item.name" :label="item.name" :value="item.url">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import vueSeamlessScroll from 'vue-seamless-scroll'

	export default {
		components: {
			vueSeamlessScroll
		},
		data() {
			return {
				imgP: require('@/assets/image/p.png'),
				imgE: require('@/assets/image/e.png'),
				imgM: require('@/assets/image/m.png'),
				imgZ: require('@/assets/image/zhuce.png'),
				banners: [],
				dataLength: [1, 2, 3, 4],
				classOption: {
					limitMoveNum: 2,
					direction: 2,
				},
				value: '',
				logoData: [],
				isActive: 1,
				activeTab: 'dynamic', // 默认显示协会动态
				listData: [{
					name: '消毒服务机构',
					id: 1,
				}, {
					name: '消毒检测评价机构备案公示名单',
					id: 2
				}],
				animate: false,
				trainningData: false,
				// ==================================
				dataNotice: '', // 协会公告的数据
				dataIndustryNews: [], // 行业动态数据
				dataDynamic: [], // 协会动态数据
				CompanyLink: [], // 直属单位
				CompanyValue: '会员单位',
				departmentLink: [], // 政府部门
				departmentValue: '政府部门',
				noticeData: [],
				dataTraining: [], // 消毒知识和技能培训
				organizationLink: [], // 协会组织
				organizationValue: '协会组织',
				internationalLink: [], // 国际组织
				// 自动轮播相关
				autoRotateTimer: null, // 定时器
				tabOrder: ['dynamic', 'news', 'notice'], // 标签顺序
			}
		},
		created() {
			this.getIndustryNews();
			this.getDynamic();
			this.getlick();
			this.getNotice();
			this.getlistgetImg();
		},
		mounted() {
			// 启动自动轮播
			this.startAutoRotate();
		},
		beforeDestroy() {
			// 清理定时器
			this.stopAutoRotate();
		},
		methods: {
			// 新增: 切换标签功能
			switchTab(tab) {
				this.activeTab = tab;
				// 手动切换后重新开始自动轮播
				this.stopAutoRotate();
				this.startAutoRotate();
			},
			// 新增: 跳转到更多页面
			goToMore() {
				switch(this.activeTab) {
					case 'dynamic':
						this.$router.push('/dynamic');
						break;
					case 'news':
						this.$router.push('/standard');
						break;
					case 'notice':
						this.$router.push('/notice');
						break;
				}
			},
			// 新增: 获取记录图标
			getRecordIcon(index) {
				// 这里可以根据实际情况返回不同的图标
				return 'img/img_default.jpg';
			},
			jump: function (index) {
				if (index == 1) {
					window.open('http://member.cdda2021.com?fromWebsite=1')
				} else {
					window.open('http://member.cdda2021.com')
				}
			},
			recordClick(row) {
				if (row.id == 1) {
					this.$router.push({
						path: '/disinfectionService',
					})
				} else {
					this.$router.push({
						path: '/disinfectionTest',
					})
				}
			},
			dataNoticeClick(item) {
        if (item.directUrl) {
          // 确保URL是完整的，如果不是以http开头，则添加http://
          let url = item.directUrl;
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'http://' + url;
          }
          window.open(url, '_blank');
        } else {
          // 否则使用原来的路由跳转逻辑
          this.$router.push({
            path: '/focus/details',
            query: {
              id: item.id,
              isActive: 2,
            }
          })
        }

			},
			noticeClick(item) {
				this.$router.push({
					path: '/zone/details',
					query: {
						id: item.id,
						isActive: 2,
					}
				})
			},
			dataTrainingClick(item) {
				this.$router.push({
					path: '/focus/details',
					query: {
						id: item.id,
						isActive: 2,
					}
				})
			},
			imgClick(row) {
				this.$router.push({
					path: '/zone/details',
					query: {
						id: row.titleId,
						isActive: 1,
					}
				})
			},
			// 会员登录
			clickLogin() {
				this.$router.push({
					path: '/login',
				})
			},
			// 会员注册
			clickRegister() {
				this.$router.push({
					path: '/register',
				})
			},
			// 获取主页轮播图
			getlistgetImg() {
				this.$axios.get('/websiteData/title/getImg').then(res => {
					this.banners = res.data.data;
				})
				this.$axios.get('/websiteData/member/getAll').then(res => {
					this.logoData = res.data.data;
				})
			},
			// 获取行业动态的数据
			getIndustryNews() {
				this.$axios.get('/websiteData/title/getTitleType/statutereg').then(res => {
					this.dataIndustryNews = res.data.data;
				})
			},
			// 获取协会动态的数据
			getDynamic() {
				this.$axios.get('/websiteData/title/listPage?subtype=dynamic').then(res => {
					this.dataDynamic = res.data.rows;
				})
			},
			// 获取协会公告的数据
			getNotice() {
				this.$axios.get('/websiteData/title/getTitleBySubType/credit').then(
					res => { // ------------------------------------
						this.noticeData = res.data.data;
					})
				this.$axios.get('/websiteData/title/getTitleBySubType/notice').then(res => {
					this.dataNotice = res.data.data;
				})
				this.$axios.get('/websiteData/title/getTitleBySubType/DisinfectionTraining').then(res => {
					this.dataTraining = res.data.data;
				})
			},
			// 获取友情链接的数据
			getlick() {
				this.$axios.get('/websiteData/links/getLinksByType').then(res => {
					this.CompanyLink = res.data.data.Company;
					this.departmentLink = res.data.data.department;
					this.organizationLink = res.data.data.organization;
					this.internationalLink = res.data.data.international;
					this.mediaLink = res.data.data.media;
				})
			},
			// 行业动态详情
			onClickData(item) {

        if (item.directUrl) {
          // 确保URL是完整的，如果不是以http开头，则添加http://
          let url = item.directUrl;
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'http://' + url;
          }
          window.open(url, '_blank');
        } else {
          // 否则使用原来的路由跳转逻辑
          this.$router.push({
            path: '/statute/details',
            query: {
              id: item.id,

            }
          })
        }

			},
			// 协会动态详情
			onClickDataFocus(item) {
        if (item.directUrl) {
          // 确保URL是完整的，如果不是以http开头，则添加http://
          let url = item.directUrl;
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'http://' + url;
          }
          window.open(url, '_blank');
        } else {
          // 否则使用原来的路由跳转逻辑
          this.$router.push({
            path: '/focus/details',
            query: {
              id: item.id,

            }
          })
        }

			},
			// 跳转到协会动态
			linkTo(item) {
				this.$router.push({
					path: '/focus/details',
					query: {
						id: item.id,
						isActive: this.isActive
					}
				})
			},
			// 友情链接地址
			comChange(res) {
				window.open(res);
			},
			depChange(res) {
				window.open(res);
			},
			orgChange(res) {
				window.open(res);
			},
			// 自动轮播方法
			startAutoRotate() {
				this.autoRotateTimer = setInterval(() => {
					const currentIndex = this.tabOrder.indexOf(this.activeTab);
					const nextIndex = (currentIndex + 1) % this.tabOrder.length;
					this.activeTab = this.tabOrder[nextIndex];
				}, 4000); // 每4秒切换一次
			},
			stopAutoRotate() {
				if (this.autoRotateTimer) {
					clearInterval(this.autoRotateTimer);
					this.autoRotateTimer = null;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
    /* 基础样式 */
    .w {
        width: 100%;
    }

    .df {
        display: flex;
    }

    .df-between {
        justify-content: space-between;
    }

    .align-center {
        align-items: center;
    }

    .df-justify-center {
        justify-content: center;
    }

    .df-shrink {
        flex-shrink: 0;
    }

    .df-flex-auto {
        flex: 1;
    }

    .pr {
        position: relative;
    }

    .oh {
        overflow: hidden;
    }

    .db {
        display: block;
    }

    .wh {
        width: 100%;
        height: 100%;
    }

    .th {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .es {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .fz {
        font-size: 0;
    }

    .bg {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* 主体样式 */
    .index {
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
        background: #fff;
    }

    /* 顶部信息区域 */
    #index-top-info {
        margin-bottom: 20px;
        margin-top: 30px;

        > .left {
            width: 750px;
            height: 340px;
            margin-right: 24px;
            position: relative;

            .carousel-wrapper {
                width: 100%;
                height: 100%;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            }
        }
    }

    /* 标签框样式 */
    .index-info-box {
        .tab-box {
            border-bottom: 2px solid #205080;
            margin-bottom: 15px;

            .tab {
                padding-bottom: 12px;

                a {
                    font-size: 18px;
                    color: #333;
                    position: relative;
                    padding-bottom: 11px;
                    margin-right: 30px;
                    transition: .4s;
                    text-decoration: none;
                    cursor: pointer;

                    &:last-child {
                        margin-right: 0;
                    }

                    &::after {
                        content: '';
                        display: block;
                        width: 0%;
                        height: 2px;
                        background-color: #ed8d05;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        z-index: 10;
                        transition: .4s;
                    }

                    &.on::after,
                    &:hover::after {
                        width: 100%;
                        opacity: 1;
                        visibility: visible;
                        box-shadow: 0 2px 4px rgba(237, 141, 5, 0.3);
                    }

                    &.on {
                        color: #205080;
                        transform: scale(1.05);
                        font-weight: 600;
                    }

                    &:hover {
                        color: #205080;
                    }
                }
            }

            .more {
                font-size: 14px;
                color: #787878;
                transition: .4s;
                text-decoration: none;
                cursor: pointer;

                &:hover {
                    color: #205080;
                }
            }
        }

        .info-list {
            max-height: 340px;
            overflow-y: auto;

            ul {
                display: none;
                list-style: none;
                padding: 0;
                margin: 0;

                &.on {
                    display: block;
                    animation: fadeInUp 0.5s ease;
                }

                li {
                    margin-bottom: 15px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    a {
                        color: #333;
                        text-decoration: none;
                        transition: .3s;
                        padding: 8px 0;

                        .title {
                            font-size: 14px;
                            color: #333;
                            transition: .4s;
                        }

                        .time {
                            font-size: 12px;
                            color: #888;
                            transition: .4s;
                        }

                        &:hover {
                            .title {
                                text-indent: 5px;
                                color: #205080;
                            }

                            .time {
                                color: #205080;
                            }
                        }
                    }
                }
            }

            .info-list-top {
                margin-bottom: 20px;

                .img-box {
                    width: 120px;
                    height: 80px;
                    margin-right: 15px;

                    i {
                        width: 100%;
                        height: 100%;
                        display: block;
                        border-radius: 4px;
                        transition: .4s;
                    }
                }

                .info {
                    .title {
                        font-size: 16px;
                        color: #202020;
                        margin-top: 3px;
                        transition: .4s;
                        margin-bottom: 8px;
                    }

                    .desc {
                        font-size: 12px;
                        color: #777;
                        line-height: 1.4;
                        margin: 0;
                    }
                }

                &:hover {
                    .img-box i {
                        transform: scale(1.1);
                    }

                    .title {
                        color: #205080;
                    }
                }
            }
        }
    }

    /* 登录按钮区域 */
    #index-type {
        margin: 20px 0;

        a {
            flex-direction: column;
            padding: 20px 40px;
            min-width: 180px;
            border: 1px solid #ddd;
            border-radius: 8px;
            text-decoration: none;
            transition: all 0.3s ease;
            background: white;

            &:hover {
                border-color: #205080;
                background-color: #f8f9ff;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(32, 80, 128, 0.15);
            }

            img {
                height: 24px;
                width: auto;
                margin-bottom: 8px;
                transition: transform 0.3s ease;
            }

            em {
                font-size: 14px;
                color: #333;
                font-style: normal;
                font-weight: 500;
            }

            &:hover {
                em {
                    color: #205080;
                }

                img {
                    transform: scale(1.1);
                }
            }
        }
    }

    /* 中心内容区域 */
    #index-center-info {
        > .left,
        > .right,
        .video-box {
            width: 32%;

            .index-info-box {
                height: 280px; /* 固定高度确保一致性 */

                .info-list {
                    height: 220px; /* 内容区域固定高度 */
                    overflow-y: auto;

                    ul {
                        li {
                            margin-bottom: 12px;

                            a {
                                padding: 8px 0;
                                height: 32px; /* 固定每行高度 */

                                .title {
                                    max-width: 300px; /* 增加标题显示宽度 */
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }

                                .time {
                                    min-width: 80px; /* 确保时间显示完整 */
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                }
            }
        }

        .info-list-type {
            padding-top: 15px;

            ul {
                margin: 0 -10px;
                list-style: none;
                padding: 0;
            }

            li {
                display: inline-block;
                vertical-align: top;
                width: calc(100% / 3);
                height: 120px;
                text-align: center;
                padding: 0 10px;
                margin-bottom: 18px;

                a {
                    border: 1px solid #ddd;
                    padding-top: 20px;
                    border-radius: 8px;
                    transition: .3s;
                    color: #333;
                    text-decoration: none;
                    height: 100%;

                    img {
                        height: 40px;
                        transition: .5s;
                        margin-bottom: 10px;
                    }

                    p {
                        font-size: 12px;
                        color: #333;
                        margin: 0;
                    }

                    &:hover {
                        border-color: #205080;

                        img {
                            transform: rotate(360deg);
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .index {
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        min-height: 100vh;

        .carousel-section {
            width: 100%;
            padding: 20px 0;

            .carousel-container {
                max-width: 1400px;
                margin: 0 auto;
                padding: 0 20px;

                .carousel-wrapper {
                    border-radius: 15px;
                    overflow: hidden;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.1);
                }
            }
        }

        .main-wrapper {
            width: 100%;
            padding: 20px 0 40px 0;

            .main-wrapper-container {
                max-width: 1400px;
                margin: 0 auto;
                padding: 0 20px;
                display: grid;
                grid-template-columns: 1fr 350px;
                gap: 30px;
                align-items: start;

                .main-content {
                    min-width: 0; /* Prevent grid overflow */

                    .core-sections-container {
                        display: flex;
                        flex-direction: column;
                        gap: 30px;

                        .section-block {
                            background: white;
                            border-radius: 15px;
                            box-shadow: 0 8px 32px rgba(0,0,0,0.08);
                            overflow: hidden;
                            transition: transform 0.3s ease;

                            &:hover {
                                transform: translateY(-5px);
                            }

                            .section-title {
                                padding: 25px 30px;
                                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                                color: white;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                .title-content {
                                    display: flex;
                                    align-items: center;

                                    i {
                                        font-size: 24px;
                                        margin-right: 15px;
                                    }

                                    h2 {
                                        margin: 0;
                                        font-size: 20px;
                                        font-weight: 600;
                                    }
                                }

                                .more-btn {
                                    padding: 8px 16px;
                                    background: rgba(255,255,255,0.2);
                                    border-radius: 20px;
                                    font-size: 12px;
                                    cursor: pointer;
                                    transition: all 0.3s ease;

                                    &:hover {
                                        background: rgba(255,255,255,0.3);
                                        transform: scale(1.05);
                                    }
                                }
                            }

                            .section-body {
                                padding: 30px;

                                .news-list {
                                    display: flex;
                                    flex-direction: column;

                                    .news-item {
                                        display: flex;
                                        align-items: center;
                                        padding: 15px;
                                        border-radius: 10px;
                                        margin-bottom: 15px;
                                        cursor: pointer;
                                        transition: all 0.3s ease;
                                        border: 2px solid #f8f9ff;

                                        &:hover {
                                            background: #f8f9ff;
                                            border-color: #667eea;
                                            transform: translateX(5px);
                                        }

                                        &:last-child {
                                            margin-bottom: 0;
                                        }

                                        .news-index {
                                            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                                            color: white;
                                            width: 30px;
                                            height: 30px;
                                            border-radius: 50%;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            font-weight: bold;
                                            font-size: 12px;
                                            margin-right: 15px;
                                        }

                                        .news-content {
                                            flex: 1;

                                            h4 {
                                                margin: 0 0 4px 0;
                                                font-size: 14px;
                                                font-weight: 600;
                                                color: #333;
                                            }

                                            .news-meta {
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;

                                                .news-date {
                                                    color: #666;
                                                    font-size: 12px;
                                                }

                                                .news-tag {
                                                    background: rgba(102, 126, 234, 0.1);
                                                    color: #667eea;
                                                    padding: 2px 8px;
                                                    border-radius: 10px;
                                                    font-size: 10px;
                                                    font-weight: 500;
                                                }
                                            }
                                        }

                                        .news-arrow {
                                            color: #ccc;
                                            transition: all 0.3s ease;
                                        }

                                        &:hover .news-arrow {
                                            color: #667eea;
                                            transform: translateX(3px);
                                        }
                                    }
                                }
                            }

                            &.notice-block .section-title {
                                background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                            }

                            &.notice-block .news-item .news-index {
                                background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                            }

                            &.dynamic-block .section-title {
                                background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                            }

                            &.dynamic-block .news-item .news-index {
                                background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                            }

                            &.industry-block .section-title {
                                background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
                            }

                            &.industry-block .news-item .news-index {
                                background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
                            }
                        }
                    }
                }

                .sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 25px;
                    min-width: 0; /* Prevent grid overflow */

                    .widget-card {
                        background: white;
                        border-radius: 15px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.08);
                        overflow: hidden;

                        .widget-header {
                            padding: 20px 25px;
                            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                            color: white;

                            h3 {
                                margin: 0;
                                font-size: 16px;
                                font-weight: 600;
                                display: flex;
                                align-items: center;

                                i {
                                    margin-right: 10px;
                                    font-size: 18px;
                                }
                            }
                        }

                        &.login-widget {
                            .login-options {
                                padding: 25px;

                                .login-row {
                                    display: flex;
                                    gap: 12px;
                                    margin-bottom: 12px;

                                    &:last-child {
                                        margin-bottom: 0;
                                    }

                                    .login-btn {
                                        flex: 1;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: center;
                                        padding: 15px 10px;
                                        border: 2px solid #f0f0f0;
                                        border-radius: 10px;
                                        background: white;
                                        cursor: pointer;
                                        transition: all 0.3s ease;

                                        &:hover {
                                            border-color: #667eea;
                                            background: #f8f9ff;
                                            transform: translateY(-2px);
                                        }

                                        img {
                                            width: 32px;
                                            height: 32px;
                                            margin-bottom: 8px;
                                        }

                                        span {
                                            font-size: 12px;
                                            color: #666;
                                            font-weight: 500;
                                        }
                                    }
                                }
                            }
                        }

                        &.training-widget {
                            .training-content {
                                padding: 25px;

                                .training-item {
                                    display: flex;
                                    align-items: center;
                                    padding: 15px;
                                    border-radius: 10px;
                                    margin-bottom: 15px;
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    border: 2px solid #f8f9ff;

                                    &:hover {
                                        background: #f8f9ff;
                                        border-color: #667eea;
                                        transform: translateX(5px);
                                    }

                                    &:last-child {
                                        margin-bottom: 0;
                                    }

                                    .training-icon {
                                        width: 40px;
                                        height: 40px;
                                        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
                                        border-radius: 50%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        margin-right: 15px;

                                        i {
                                            color: white;
                                            font-size: 18px;
                                        }
                                    }

                                    .training-info {
                                        flex: 1;

                                        h4 {
                                            margin: 0 0 4px 0;
                                            font-size: 14px;
                                            font-weight: 600;
                                            color: #333;
                                        }

                                        .training-desc {
                                            margin: 0 0 6px 0;
                                            font-size: 12px;
                                            color: #666;
                                        }

                                        .training-date {
                                            font-size: 11px;
                                            color: #999;
                                        }
                                    }

                                    .training-arrow {
                                        color: #ccc;
                                        transition: all 0.3s ease;
                                    }

                                    &:hover .training-arrow {
                                        color: #667eea;
                                        transform: translateX(3px);
                                    }
                                }
                            }
                        }

                        &.record-widget {
                            .record-content {
                                padding: 25px;

                                .record-item {
                                    display: flex;
                                    align-items: center;
                                    padding: 20px;
                                    border-radius: 12px;
                                    margin-bottom: 20px;
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    background: #f8f9ff;
                                    border: 2px solid transparent;

                                    &:hover {
                                        background: white;
                                        border-color: #667eea;
                                        transform: translateY(-3px);
                                        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
                                    }

                                    &:last-child {
                                        margin-bottom: 0;
                                    }

                                    .record-icon {
                                        width: 50px;
                                        height: 50px;
                                        background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
                                        border-radius: 12px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        margin-right: 15px;

                                        i {
                                            color: white;
                                            font-size: 22px;
                                        }
                                    }

                                    .record-info {
                                        flex: 1;

                                        h4 {
                                            margin: 0 0 6px 0;
                                            font-size: 15px;
                                            font-weight: 600;
                                            color: #333;
                                        }

                                        .record-desc {
                                            margin: 0 0 10px 0;
                                            font-size: 12px;
                                            color: #666;
                                            line-height: 1.4;
                                        }

                                        .record-features {
                                            display: flex;
                                            gap: 6px;

                                            .feature-tag {
                                                background: rgba(102, 126, 234, 0.1);
                                                color: #667eea;
                                                padding: 2px 8px;
                                                border-radius: 10px;
                                                font-size: 10px;
                                                font-weight: 500;
                                            }
                                        }
                                    }

                                    .record-arrow {
                                        color: #ccc;
                                        transition: all 0.3s ease;
                                    }

                                    &:hover .record-arrow {
                                        color: #667eea;
                                        transform: translateX(3px);
                                    }
                                }
                            }
                        }

                        &.member-widget {
                            .member-content {
                                padding: 25px;

                                .member-item {
                                    display: flex;
                                    align-items: center;
                                    padding: 15px;
                                    border-radius: 10px;
                                    margin-bottom: 15px;
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    border: 2px solid #f8f9ff;

                                    &:hover {
                                        background: #f8f9ff;
                                        border-color: #667eea;
                                        transform: translateX(5px);
                                    }

                                    &:last-child {
                                        margin-bottom: 0;
                                    }

                                    .member-date {
                                        width: 40px;
                                        height: 40px;
                                        background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
                                        border-radius: 50%;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: center;
                                        justify-content: center;
                                        margin-right: 15px;

                                        .date-day {
                                            font-size: 18px;
                                            font-weight: 600;
                                            color: white;
                                        }

                                        .date-month {
                                            font-size: 12px;
                                            color: white;
                                        }
                                    }

                                    .member-info {
                                        flex: 1;

                                        h4 {
                                            margin: 0 0 4px 0;
                                            font-size: 14px;
                                            font-weight: 600;
                                            color: #333;
                                        }

                                        p {
                                            margin: 0;
                                            font-size: 12px;
                                            color: #666;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .member-showcase-section {
            width: 100%;
            padding: 40px 0;


            .container {
                max-width: 1400px;
                margin: 0 auto;
                padding: 0 20px;

                .showcase-header {
                    text-align: center;
                    margin-bottom: 30px;

                    h2 {
                        margin: 0 0 10px 0;
                        font-size: 24px;
                        font-weight: 600;
                        color: #333;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        i {
                            margin-right: 10px;
                            font-size: 24px;
                            color: #205080;
                        }
                    }

                    p {
                        margin: 0;
                        font-size: 14px;
                        color: #666;
                    }
                }

                .member-scroll {
                    height: 150px;
                    overflow: hidden;
                    background: #f8f9ff;
                    border-radius: 10px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);

                    .scroll-wrapper {
                        height: 100%;

                        .member-logos {
                            display: flex;
                            align-items: center;
                            height: 100%;
                            list-style: none;
                            margin: 0;
                            padding: 0;

                            .logo-item {
                                flex-shrink: 0;
                                height: 110px;
                                margin: 0 25px;
                                cursor: pointer;
                                transition: transform 0.3s ease;

                                &:hover {
                                    transform: scale(1.15);
                                }

                                img {
                                    height: 100%;
                                    width: auto;
                                    max-width: 160px;
                                    object-fit: contain;
                                    border-radius: 8px;
                                    box-shadow: 0 3px 12px rgba(0,0,0,0.15);
                                }
                            }
                        }
                    }
                }
            }
        }

        .links-section {
            width: 100%;
            padding: 40px 0;

            .container {
                max-width: 1400px;
                margin: 0 auto;
                padding: 0 20px;

                .links-header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;

                    img {
                        width: 24px;
                        height: 24px;
                        margin-right: 15px;
                    }

                    h2 {
                        margin: 0;
                        font-size: 24px;
                        font-weight: 600;
                        color: #333;
                    }
                }

                .links-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 20px;

                    .link-group {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;

                        label {
                            font-size: 14px;
                            color: #333;
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }
</style>

<style>
    /* Element UI customizations */
    .el-select .el-input--suffix .el-input__inner {
        height: 35px;
        line-height: 35px;
        border: 2px solid #f0f0f0;
        border-radius: 8px;
        color: #333;
        font-size: 14px;
        transition: all 0.3s ease;
    }

    .el-select .el-input--suffix .el-input__inner:focus {
        border-color: #667eea;
    }

    .el-select .el-input--suffix .el-input__suffix .el-input__suffix-inner .el-input__icon {
        line-height: 35px;
        color: #666;
    }

    .el-carousel__item img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }

    .el-carousel__item p {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 999;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
        width: 100%;
        height: 80px;
        color: #fff;
        font-size: 16px;
        padding: 20px;
        margin: 0;
        display: flex;
        align-items: flex-end;
    }

    .el-carousel__button {
        background-color: rgba(255, 255, 255, 0.8);
    }

    .el-carousel__indicators--horizontal {
        bottom: 20px;
    }

    .el-carousel__indicator.is-active button {
        background-color: #667eea;
    }
</style>
